import {TagProps} from 'antd/es/tag';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import {getIncrease} from 'lib/utils';
import React from 'react';

type Props = {
  oldValue: number;
  newValue: number;
  reverse?: boolean;
} & TagProps;

const getColor = (increase: number) => {
  if (increase > 0) return colors.success;
  if (increase < 0) return colors.yellow;
  return colors.grey;
};

export const IncreaseTag: React.FC<Props> = ({oldValue, newValue, color, reverse, ...props}) => {
  const increase = getIncrease(newValue, oldValue);
  return (
    <StatusTag {...props} color={getColor((reverse ? -1 : 1) * increase)}>
      {increase > 0 && '+'}
      {increase.toFixed(1)}%
    </StatusTag>
  );
};
